(function() {
  function isAddToCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var hasVariantId = form.querySelector('input[name="id"]');
    var action = form.getAttribute('action') || form.action || '';
    var isCartForm = (action.indexOf('cart/add') !== -1) || form.getAttribute('data-type') === 'add-to-cart-form';
    return hasVariantId && isCartForm;
  }

  function getFormFromButton(btn) {
    return btn && btn.form ? btn.form : (btn && btn.closest ? btn.closest('form') : null);
  }

  function doAjaxAddToCart(form, submitBtn, productFormEl, spinner) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var config = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } };
    var formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sections = cart.getSectionsToRender();
      sections.forEach(function(s) { formData.append('sections[]', s.id); });
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    var addUrl = (typeof routes !== 'undefined' && routes.cart_add_url && routes.cart_add_url.replace(/\/add\/?$/, '/add.js')) || '/cart/add.js';
    fetch(addUrl, config)
      .then(function(r) { return r.json(); })
      .then(function(response) {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.errors || response.description, message: response.message });
          }
          if (productFormEl && typeof productFormEl.handleErrorMessage === 'function') productFormEl.handleErrorMessage(response.description);
          return;
        }
        var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!cartEl) {
          if (typeof routes !== 'undefined' && routes.cart_url) window.location = routes.cart_url;
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
        }
        var quickAddModal = form.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', function() {
            setTimeout(function() { cartEl.renderContents(response); });
          }, { once: true });
          if (typeof quickAddModal.hide === 'function') quickAddModal.hide(true);
        } else {
          cartEl.renderContents(response);
        }
      })
      .catch(function(e) { console.error('Error adding to cart:', e); })
      .finally(function() {
        delete form.dataset.addToCartHandled;
        if (submitBtn) {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        if (typeof window.BOLD !== 'undefined' && window.BOLD.common && window.BOLD.common.eventEmitter && typeof window.BOLD.common.eventEmitter.emit === 'function') {
          window.BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
        }
      });
  }

  function handleAddToCartSubmit(evt) {
    var form = evt.target;
    if (!isAddToCartForm(form)) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    form.dataset.addToCartHandled = '1';

    var submitBtn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    var productFormEl = form.closest('product-form');
    var spinner = (productFormEl && productFormEl.querySelector('.loading__spinner')) || form.querySelector('.loading__spinner');

    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');
    doAjaxAddToCart(form, submitBtn, productFormEl, spinner);
  }

  function handleAddToCartClick(evt) {
    var btn = evt.target.closest ? evt.target.closest('button[type="submit"][name="add"], button[type="submit"].quick-add__submit') : null;
    if (!btn || btn.disabled) return;
    var form = getFormFromButton(btn);
    if (!form || !isAddToCartForm(form) || form.dataset.addToCartHandled === '1') return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    form.dataset.addToCartHandled = '1';
    var productFormEl = form.closest('product-form');
    var spinner = (productFormEl && productFormEl.querySelector('.loading__spinner')) || form.querySelector('.loading__spinner');
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');
    doAjaxAddToCart(form, btn, productFormEl, spinner);
  }

  function stubAddToCartFormActions() {
    document.querySelectorAll('form[data-type="add-to-cart-form"], form[action*="cart/add"]').forEach(function(f) {
      if (f.querySelector('input[name="id"]')) f.setAttribute('action', '#');
    });
  }

  document.addEventListener('submit', handleAddToCartSubmit, true);
  document.addEventListener('click', handleAddToCartClick, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stubAddToCartFormActions);
  } else {
    stubAddToCartFormActions();
  }
  setTimeout(stubAddToCartFormActions, 500);
})();

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        
        // Prevent multiple initializations
        if (this.dataset.initialized === 'true') {
          return;
        }
        
        this.form = this.querySelector('form');
        if (!this.form) {
          return;
        }
        
        // Safe access to variantIdInput
        if (!this.variantIdInput) {
          return;
        }
        
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) {
          return;
        }
        
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Mark as initialized to prevent duplicate processing
        this.dataset.initialized = 'true';
      }

      onSubmitHandler(evt) {
        if (evt.target.dataset.addToCartHandled === '1') return;
        evt.preventDefault();
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (cartDrawer) {
          const sections = cartDrawer.getSectionsToRender();
          sections.forEach((section) => formData.append('sections[]', section.id));
          formData.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement(document.activeElement);
        }
        config.body = formData;
        config.headers['Accept'] = 'application/json';

        const addUrl = (routes.cart_add_url && routes.cart_add_url.replace(/\/add\/?$/, '/add.js')) || '/cart/add.js';
        fetch(addUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
            const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('Error adding to cart:', e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            const cartEl = document.querySelector('cart-drawer');
            if (cartEl && cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                  typeof BOLD.common.eventEmitter.emit === 'function'){
                BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (this.submitButton === null) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        if (!this.form) return null;
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
